package com.example.mystybag.appCore.model.pages

data class SettingsPageUIState(
    val languageDisplayValue: String = "",
    val categoryDisplayValue: String = "",
    val selectedThemeCode: Int = 0,
    val isLocationPermissionGranted: Boolean = false,
    val isNotificationPermissionGranted: Boolean = false,
    /** Used as composition key so the whole page recomposes with new locale after language change. */
    val currentLanguageCode: String = ""
)
